export const strip = (o, attrs = [], values = []) => {
    if (Array.isArray(o)) {
        o.forEach(v => strip(v, attrs, values));
    } else if (isObject(o)) {
        Object.keys(o).forEach(k => {
            if (attrs.indexOf(k) !== -1 || values.indexOf(o[k]) !== -1) {
                delete o[k];
            } else if (Array.isArray(o[k])) {
                o[k].forEach(v => strip(v, attrs, values));
            } else {
                strip(o[k], attrs, values);
            }
        });
    }

    return o;
}
export const isObject = (o) => {
    return o !== null && typeof o === 'object';
}
export const isUndefined = (o) => o === null || o === undefined;

export const isDefined = (o) => o !== null && o !== undefined;

export const equalsIgnoreAttrsValues = (o1, o2, attrs, values) => {
    if (o1 === o2) {
        return true;
    }
    if (!o1 || !o2) {
        return false;
    }
    // perform a deep equals on two objects after stripping certain attributes/values
    return equals(strip(structuredClone(o1), attrs, values), strip(structuredClone(o2), attrs, values));
}

export const hasSubset = (superset, subset): boolean => {
    for (const key in subset) {
        if (!superset.hasOwnProperty(key) || superset[key] !== subset[key]) {
            return false;
        }
    }
    return true;
}
//===================================================================================================
// Some AngularJS functions. Created for compatibility. Do not use with new code
//===================================================================================================
export const equals = (o1, o2) => {
    if (o1 === o2) return true;
    if (o1 === null || o2 === null) return false;
    if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
    let t1 = typeof o1,
        t2 = typeof o2,
        length,
        key,
        keySet;
    if (t1 == t2 && t1 == 'object') {
        if (Array.isArray(o1)) {
            if (!Array.isArray(o2)) return false;
            if ((length = o1.length) == o2.length) {
                for (key = 0; key < length; key++) {
                    if (!equals(o1[key], o2[key])) return false;
                }
                return true;
            }
        } else if (isDate(o1)) {
            if (!isDate(o2)) return false;
            return equals(o1.getTime(), o2.getTime());
        } else if (isRegExp(o1)) {
            if (!isRegExp(o2)) return false;
            return o1.toString() == o2.toString();
        } else {
            if (
                isScope(o1) ||
                isScope(o2) ||
                isWindow(o1) ||
                isWindow(o2) ||
                Array.isArray(o2) ||
                isDate(o2) ||
                isRegExp(o2)
            )
                return false;
            keySet = createMap();
            for (key in o1) {
                if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
                if (!equals(o1[key], o2[key])) return false;
                keySet[key] = true;
            }
            for (key in o2) {
                if (!(key in keySet) && key.charAt(0) !== '$' && isDefined(o2[key]) && !isFunction(o2[key])) return false;
            }
            return true;
        }
    }
    return false;
}
export const isDefinedString = (o) => o !== null && o !== undefined && typeof o === 'string'  && o !== ""

export const isNumber = (value) => typeof value === 'number';

export const isDate = (value) => toString.call(value) === '[object Date]';

export const isRegExp = (value) => toString.call(value) === '[object RegExp]';

export const isWindow = (obj) => obj && obj.window === obj;

export const isScope = (obj) => obj && obj.$evalAsync && obj.$watch;

export const isFunction = (value) => typeof value === 'function';

export const createMap = () => Object.create(null);

export const isBoolean = (value: any) => typeof value === "boolean";

// ===============================================================================
// Check if value is has duplicates
// ===============================================================================
export const isDuplicateReference = (arr: string[], value: string) => {
    const seen: Set<string> = new Set();
    const nonUnique = [];

    for (const element of arr) {
        if (seen.has(element)) {
            nonUnique.push(element);
        } else {
            seen.add(element);
        }
    }
    return nonUnique.some(v => value === value);
}

// ===============================================================================
// Clean Object or Array
// by removing "empty" or "null-like" data from it
// ===============================================================================

export const clean = (item: any, key?: number | string, parent?: any): any => {
    if (item && typeof item === 'object') {
        if (parent) {
            const parentIsArray = Array.isArray(parent);
            if (isEmptyObject(item)) {
                if (parentIsArray) {
                    (parent as any[]).splice(key as number, 1);
                } else {
                    delete parent[key as string];
                }
                return item;
            } else {
                clean(item);

                if (isEmptyObject(item)) {
                    if (parentIsArray) {
                        (parent as any[]).splice(key as number, 1);
                    } else {
                        delete parent[key];
                    }
                }
            }
        } else if (Array.isArray(item)) {
            for (let i = item.length - 1; i >= 0; i--) {
                clean(item[i], i, item);
            }
        } else {
            Object.keys(item).forEach(k => clean(item[k], k, item));
        }
    }

    return item;
};

export const isEmptyObject = (obj: any): boolean => {
    return obj && Object.keys(obj).length === 0;
};


export const isValidNumber = (value: number) => {
    return value !== null && value !==undefined && !isNaN(value);
}

export const isValidString = (value: string) => {
    return !!value?.trim();
}

export const isArrayDifferent = (arr1: any[], arr2: any[]) => {
    if (arr1.length !== arr2.length) {
        return true;
    }
    return arr1.some((value, index) => value !== arr2[index]);
};
